import React, { Dispatch, SetStateAction, useCallback } from 'react'
import {
  FormControl,
  FormLabel,
  InputGroup,
  Input,
  InputRightElement,
  Spinner,
  Menu,
  MenuButton,
  VStack,
  MenuList,
  FormErrorMessage
} from '@chakra-ui/react'
import debounce from 'lodash/debounce'
import get from 'lodash/get'
import { useFormContext } from 'react-hook-form'
import DropdownSelection from 'components/pages/DetailPage/components/DropdownSelection'
import { getValidArray } from 'utils/common'
import { IAddressOption } from '../..'
import { ResultWrapper } from './autoFillInput.styles'

interface IAutoFillInputProps {
  isLoading: boolean
  defaultOptions: IAddressOption[]
  setDefaultOptions: Dispatch<SetStateAction<IAddressOption[]>>
  setChosenAddress: Dispatch<SetStateAction<IAddressOption | undefined>>
  setAddress: Dispatch<SetStateAction<string>>
  isOpenDropdown: boolean
  onCloseDropdown: () => void
}

const AutoFillInput = (props: IAutoFillInputProps) => {
  const {
    isLoading,
    defaultOptions,
    setDefaultOptions,
    setChosenAddress,
    setAddress,
    isOpenDropdown,
    onCloseDropdown
  } = props
  const {
    register,
    formState: { errors }
  } = useFormContext()
  const changeAddress = useCallback(
    debounce((event: { target: { value: string } }) => {
      setAddress(event?.target?.value ?? '')
    }, 1000),
    []
  )

  function onClickDropdownOption(option: IAddressOption): void {
    setChosenAddress(option)
    setDefaultOptions([])
    onCloseDropdown()
  }

  return (
    <VStack alignItems="flex-start" width={'100%'} spacing={0}>
      <FormControl isInvalid={!!get(errors, 'addressLine1', false)}>
        <FormLabel color="gray.700" lineHeight={6} marginInlineEnd={0}>
          Address Line 1
        </FormLabel>
        <InputGroup>
          <Input
            autoComplete="off"
            placeholder="e.g. 1 Shadyhill Road"
            {...register('addressLine1', {
              required: 'Address Line 1 is required'
            })}
            onChange={changeAddress}
          />
          <InputRightElement>{isLoading && <Spinner size="sm" />}</InputRightElement>
        </InputGroup>
        <Menu autoSelect={false} computePositionOnMount matchWidth isOpen={isOpenDropdown}>
          <MenuButton visibility="hidden" maxH="0" fontSize="md" marginTop="-24px !important"></MenuButton>
          <ResultWrapper spacing={0}>
            <MenuList zIndex={100}>
              {getValidArray(defaultOptions).map((option: IAddressOption, index: number) => (
                <DropdownSelection
                  key={`addressLine1-${index}`}
                  onClick={() => {
                    onClickDropdownOption(option)
                  }}
                  label={option?.label}
                  width="full"
                />
              ))}
            </MenuList>
          </ResultWrapper>
        </Menu>
        <FormErrorMessage>{get(errors, 'addressLine1.message', '')}</FormErrorMessage>
      </FormControl>
    </VStack>
  )
}

export default AutoFillInput
